/** A nested value shows the names under it: a selector's input names say what a step reads. */
export function configChipValue(value: unknown): string {
  if (value !== null && typeof value === 'object') {
    return Array.isArray(value) ? value.map(String).join(', ') : Object.keys(value).join(', ');
  }
  return String(value);
}
